import { Link } from 'react-router-dom';

export function NotFoundPage() {
  return (
    <div className="card mx-auto mt-12 max-w-lg text-center">
      <div className="text-xs uppercase tracking-widest text-bn-700">404</div>
      <h1 className="mt-2 text-xl font-semibold text-slate-900">Page not found</h1>
      <p className="mt-2 text-sm text-slate-500">
        The page you&rsquo;re looking for has moved or never existed.
      </p>
      <Link to="/" className="btn-primary mt-4">
        Back to dashboard
      </Link>
    </div>
  );
}
